var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "setup__btnGroup", class: { disabled: _vm.disabled } },
    [
      _vm.showLabel
        ? _c(
            "div",
            { staticClass: "setup__text" },
            [
              _vm._t("label", function() {
                return [
                  _c("span", [
                    _vm._v(
                      _vm._s(_vm.labelPrefix) +
                        _vm._s(_vm.isOn ? _vm.labelOn : _vm.labelOff)
                    )
                  ])
                ]
              })
            ],
            2
          )
        : _vm._e(),
      _c(
        "div",
        {
          staticClass: "setup__outer",
          class: { active: _vm.isOn },
          attrs: {
            role: "switch",
            "aria-checked": _vm.isOn.toString(),
            "aria-disabled": _vm.disabled.toString(),
            tabindex: "0"
          },
          on: {
            click: _vm.toggle,
            keydown: function($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter") &&
                _vm._k($event.keyCode, "space", 32, $event.key, [
                  " ",
                  "Spacebar"
                ])
              ) {
                return null
              }
              return _vm.toggle.apply(null, arguments)
            }
          }
        },
        [_c("div", { staticClass: "setup__inner" })]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }